/* unplugin-vue-components disabled */import script from "./CreateInteraction.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateInteraction.vue?vue&type=script&setup=true&lang=js"

import "./CreateInteraction.vue?vue&type=style&index=0&id=7a38b586&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a38b586"]])

export default __exports__